import { jsx as _jsx } from "react/jsx-runtime";
import { CounterMinusIconS } from '@lichtblick/icons/svg/counter-minus/counter-minus-s';
import { CounterPlusIconS } from '@lichtblick/icons/svg/counter-plus/counter-plus-s';
import { forwardRef, useCallback } from 'react';
import { StepperButton, StyledStepper } from './Stepper.styles';
/**
 * ! Controlled state only
 * Handles min/max via button but also via text input.
 * `onCountChange` is only called with a valid number or an empty string.
 */ export const Stepper = /*#__PURE__*/ forwardRef(({ 'data-testid': testid = 'counter', isDisabled, max = Infinity, min = 0, onChange, step = 1, value, ...props }, ref)=>{
    const handleChange = ({ target: { value: input } })=>{
        const parsedInput = parseFloat(input);
        if (input === '') {
            onChange(undefined);
        } else if (!Number.isNaN(parsedInput) && Number.isFinite(parsedInput)) {
            onChange(parsedInput);
        }
    };
    const handleCountDown = (event)=>{
        event.preventDefault();
        if (typeof value === 'number') {
            onChange(Math.max(value - step, min));
        }
    };
    const handleCountUp = (event)=>{
        event.preventDefault();
        if (typeof value === 'number') {
            onChange(Math.min(value + step, max ?? Infinity));
        } else {
            onChange(min);
        }
    };
    return /*#__PURE__*/ _jsx(StyledStepper, {
        ...props,
        "data-testid": testid,
        inputMode: "numeric",
        isBold: true,
        isCentered: true,
        isDisabled: isDisabled,
        leftSlot: /*#__PURE__*/ _jsx(StepperButton, {
            "aria-label": `um ${step} verringern`,
            "data-testid": `${testid}_minus`,
            disabled: isDisabled || value === undefined || value <= min,
            onClick: handleCountDown,
            type: "button",
            children: /*#__PURE__*/ _jsx(CounterMinusIconS, {})
        }),
        max: max,
        min: min,
        onChange: useCallback(handleChange, []),
        ref: ref,
        rightSlot: /*#__PURE__*/ _jsx(StepperButton, {
            "aria-label": `um ${step} erhöhen`,
            "data-testid": `${testid}_plus`,
            disabled: isDisabled || value !== undefined && value >= max,
            onClick: handleCountUp,
            type: "button",
            children: /*#__PURE__*/ _jsx(CounterPlusIconS, {})
        }),
        type: "number",
        value: value ?? ''
    });
});

//# sourceMappingURL=Stepper.js.map